declare namespace $ {

	export class $bog_merchquarium_number extends $mol_number {
	}
	
}

//# sourceMappingURL=number.view.tree.d.ts.map